import {css} from 'lit';
export const styles = css`:host {
  display: block;
  background-color: var(--contrast-light);
}

.card-note {
  margin-top: 16px;
  padding-top: 4px;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  font-style: italic;
}

.card-note a {
  color: var(--text-secondary);
  text-decoration: none;
}

@media (hover: hover) {
  .card-note a:hover {
    color: var(--link-primary-hover);
  }
}

.card-note a:focus {
  color: var(--link-primary-hover);
}
`;
export default styles;
